import React from 'react';
import TableBodyMaterial from '@material-ui/core/TableBody';

const TableBody = ({ children, ...rest }) => (
  <TableBodyMaterial {...rest}>{children}</TableBodyMaterial>
);

export default TableBody;
